export default {
  "root": "_root_19u45_1",
  "--auto": "_--auto_19u45_1",
  "--color-neutral": "_--color-neutral_19u45_1",
  "--color-neutral-faded": "_--color-neutral-faded_19u45_1",
  "--color-primary": "_--color-primary_19u45_1",
  "--color-positive": "_--color-positive_19u45_1",
  "--color-warning": "_--color-warning_19u45_1",
  "--color-critical": "_--color-critical_19u45_1",
  "--color-disabled": "_--color-disabled_19u45_1"
};import "ni:sha-256;P7wzkjDKM-PcRLB8PGmKiN8DF-5sCVrRi6s-WpfEZGs";